module.exports = __webpack_public_path__ + "img/限时商品10.1ebd4166.png";